import { noop } from 'lodash';
import { Dispatch, SetStateAction } from 'react';

import { createContext } from 'use-context-selector';

export interface SectionContexState {
  collapsible: boolean;
  value: string;
}

interface SectionContextProps extends SectionContexState {
  setState: Dispatch<SetStateAction<SectionContexState>>;
}

export const SectionContext = createContext<SectionContextProps>({
  collapsible: false,
  setState: noop,
  value: null,
});
